import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngxs/store";
import { Menu, MenuItems } from "app/shared/menu-items/menu-items";
import { Map } from "immutable";
import { Observable, Subject } from "rxjs";
import { delay, filter, map, take, takeUntil, tap } from "rxjs/operators";
import { AnnualDeclarationFormCollection } from "~app/company/form/annual-declaration-form/shared/model/annual-declaration.model";
import {
    LoadAnnualDeclarationForm,
    LoadFailStrategy,
} from "~app/company/form/annual-declaration-form/shared/state/annual-declaration.actions";
import { AnnualDeclarationState } from "~app/company/form/annual-declaration-form/shared/state/annual-declaration.state";
import {
    CompanySelector,
    FormStatus,
} from "~app/company/shared/model/company.model";
import { CompanyDataService } from "~app/company/shared/service/company-data.service";

@Component({
    selector: "odq-home-legal-entity",
    templateUrl: "./home-legal-entity.component.html",
    styleUrls: ["./home-legal-entity.component.scss"],
    standalone: false
})
export class HomeLegalEntityComponent implements OnInit, OnDestroy {
  isLoading = false;
  destroy$ = new Subject<void>();
  isMemberCompanyRegisterForCurrentPeriod: boolean = null;
  hasFormEditable = false;
  isEventSourcingLoading = true;

  legalEntities: CompanySelector[];
  formState$: Observable<FormStatus>;

  year$ = this.store.select<number>(AnnualDeclarationState.year);
  formCollections$ = this.store.select<
    Map<string, AnnualDeclarationFormCollection>
  >(AnnualDeclarationState.formCollections);

  constructor(
    public translate: TranslateService,
    private store: Store,
    public menuItems: MenuItems,
    private companySelectorDataService: CompanyDataService
  ) {}

  ngOnInit() {  
    this.isLoading = true;
    this.hasFormEditable = false;

    this.menuItems.mainMenuItems$
      .pipe(
        takeUntil(this.destroy$),
        map((menuItems) => {
          this.isMemberCompanyRegisterForCurrentPeriod = menuItems.some(
            (menu: Menu) => menu.state === "company"
          );
        })
      )
      .subscribe();

    this.companySelectorDataService.userCompanies$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: CompanySelector[]) => {
        this.legalEntities = data;
        for (let legalEntity of this.legalEntities) {
          if (!!legalEntity) {
            this.year$
              .pipe(
                filter((year) => !!year),
                tap((_) => {
                  this.store
                    .dispatch(
                      new LoadAnnualDeclarationForm(
                        legalEntity?.id,
                        LoadFailStrategy.Init
                      )
                    )
                    .subscribe((_) => {
                      this.loadFormCollection(legalEntity.id);
                    });
                }),
                take(1)
              )
              .subscribe();
          }
        }
      });
  }

  loadFormCollection(legalEntityId: string) {
    let delayValue = 0;

    this.formCollections$
      .pipe(
        takeUntil(this.destroy$),
        map((value) => {
          delayValue =
            value?.get(legalEntityId)?.state === undefined ? 5000 : 0;
          return value;
        }),
        delay(delayValue)
      )
      .subscribe((cols) => {
        let state = cols?.get(legalEntityId)?.state;
        this.hasFormEditable = !(
          state === FormStatus.Initial || state === FormStatus.InProgress
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
